
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46.06","height":"46.06"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Groupe 206","transform":"translate(-19 -374)","fill":"#c22292"}},[_c('rect',{attrs:{"data-name":"Rectangle 60","width":"46.06","height":"46.06","rx":"15","transform":"translate(19 374)","opacity":".07"}}),_c('path',{attrs:{"data-name":"Tracé 5428","d":"M51.114 395.355v3.271H43.87v7.887h-3.68v-7.887h-7.244v-3.271h7.244v-7.887h3.68v7.887z"}})])])
          )
        }
      }
    